var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calcu-field" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "de-form-item",
          attrs: { model: _vm.fieldForm },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("dataset.field_edit_name") } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  placeholder: _vm.$t("dataset.input_edit_name"),
                },
                model: {
                  value: _vm.fieldForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.fieldForm, "name", $$v)
                  },
                  expression: "fieldForm.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "calcu-cont", staticStyle: { height: "544px" } },
        [
          _c(
            "div",
            { staticStyle: { flex: "1" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-row",
                    { staticStyle: { "max-width": "480px" } },
                    [
                      _c(
                        "span",
                        { staticClass: "mb8" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.field_exp")) +
                              "\n            "
                          ),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "bottom" },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("dataset.calc_tips.tip1")) +
                                      "\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("dataset.calc_tips.tip2")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _c("i", {
                                staticClass: "el-icon-info",
                                staticStyle: { cursor: "pointer" },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("codemirror", {
                        ref: "myCm",
                        staticClass: "codemirror",
                        attrs: { options: _vm.cmOption },
                        on: {
                          ready: _vm.onCmReady,
                          focus: _vm.onCmFocus,
                          input: _vm.onCmCodeChange,
                        },
                        model: {
                          value: _vm.fieldForm.originName,
                          callback: function ($$v) {
                            _vm.$set(_vm.fieldForm, "originName", $$v)
                          },
                          expression: "fieldForm.originName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticStyle: { "margin-top": "28px" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticClass: "de-form-item",
                          attrs: { model: _vm.fieldForm },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("dataset.data_type") } },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "d" },
                                  model: {
                                    value: _vm.fieldForm.groupType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fieldForm, "groupType", $$v)
                                    },
                                    expression: "fieldForm.groupType",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.dimension")))]
                              ),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "q" },
                                  model: {
                                    value: _vm.fieldForm.groupType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fieldForm, "groupType", $$v)
                                    },
                                    expression: "fieldForm.groupType",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("chart.quota")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: _vm.$t("dataset.field_type") } },
                            _vm._l(_vm.fields, function (item) {
                              return _c(
                                "el-radio",
                                {
                                  key: item.value,
                                  attrs: { label: item.value },
                                  model: {
                                    value: _vm.fieldForm.deType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fieldForm, "deType", $$v)
                                    },
                                    expression: "fieldForm.deType",
                                  },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "padding-lr" },
            [
              _c(
                "span",
                { staticClass: "mb8" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("dataset.click_ref_field")) +
                      "\n        "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip3")) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip4")) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip5")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: { cursor: "pointer" },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-input", {
                staticStyle: { "margin-bottom": "12px" },
                attrs: {
                  size: "small",
                  placeholder: _vm.$t("dataset.edit_search"),
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                model: {
                  value: _vm.searchField,
                  callback: function ($$v) {
                    _vm.searchField = $$v
                  },
                  expression: "searchField",
                },
              }),
              _c(
                "div",
                { staticClass: "field-height" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("chart.dimension")))]),
                  _vm.dimensionData && _vm.dimensionData.length > 0
                    ? _c(
                        "draggable",
                        {
                          staticClass: "drag-list",
                          attrs: {
                            options: {
                              group: { name: "drag", pull: "clone" },
                              sort: true,
                            },
                            animation: "300",
                            disabled: true,
                          },
                          model: {
                            value: _vm.dimensionData,
                            callback: function ($$v) {
                              _vm.dimensionData = $$v
                            },
                            expression: "dimensionData",
                          },
                        },
                        [
                          _c(
                            "transition-group",
                            _vm._l(_vm.dimensionData, function (item) {
                              return _c(
                                "span",
                                {
                                  key: item.id,
                                  staticClass: "item-dimension",
                                  attrs: { title: item.name },
                                  on: {
                                    click: function ($event) {
                                      return _vm.insertFieldToCodeMirror(
                                        "[" + item.name + "]"
                                      )
                                    },
                                  },
                                },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "class-na" }, [
                        _vm._v(_vm._s(_vm.$t("dataset.na"))),
                      ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "field-height" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("chart.quota")))]),
                  _vm.quotaData && _vm.quotaData.length > 0
                    ? _c(
                        "draggable",
                        {
                          staticClass: "drag-list",
                          attrs: {
                            options: {
                              group: { name: "drag", pull: "clone" },
                              sort: true,
                            },
                            animation: "300",
                            disabled: true,
                          },
                          model: {
                            value: _vm.quotaData,
                            callback: function ($$v) {
                              _vm.quotaData = $$v
                            },
                            expression: "quotaData",
                          },
                        },
                        [
                          _c(
                            "transition-group",
                            _vm._l(_vm.quotaData, function (item) {
                              return _c(
                                "span",
                                {
                                  key: item.id,
                                  staticClass: "item-quota",
                                  attrs: { title: item.name },
                                  on: {
                                    click: function ($event) {
                                      return _vm.insertFieldToCodeMirror(
                                        "[" + item.name + "]"
                                      )
                                    },
                                  },
                                },
                                [
                                  item.deType === 0
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-text",
                                        attrs: { "icon-class": "field_text" },
                                      })
                                    : _vm._e(),
                                  item.deType === 1
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-time",
                                        attrs: { "icon-class": "field_time" },
                                      })
                                    : _vm._e(),
                                  item.deType === 2 || item.deType === 3
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-value",
                                        attrs: { "icon-class": "field_value" },
                                      })
                                    : _vm._e(),
                                  item.deType === 5
                                    ? _c("svg-icon", {
                                        staticClass: "field-icon-location",
                                        attrs: {
                                          "icon-class": "field_location",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("span", [_vm._v(_vm._s(item.name))]),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "class-na" }, [
                        _vm._v(_vm._s(_vm.$t("dataset.na"))),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "padding-lr" },
            [
              _c(
                "span",
                { staticClass: "mb8" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("dataset.click_ref_function")) +
                      "\n        "
                  ),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: { effect: "dark", placement: "bottom" },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip6")) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip7")) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("dataset.calc_tips.tip8")) +
                              "\n            https://doris.apache.org/zh-CN/\n          "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass: "el-icon-info",
                        staticStyle: { cursor: "pointer" },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-input", {
                staticStyle: { "margin-bottom": "12px" },
                attrs: {
                  size: "small",
                  placeholder: _vm.$t("dataset.edit_search"),
                  "prefix-icon": "el-icon-search",
                  clearable: "",
                },
                model: {
                  value: _vm.searchFunction,
                  callback: function ($$v) {
                    _vm.searchFunction = $$v
                  },
                  expression: "searchFunction",
                },
              }),
              _c(
                "el-row",
                { staticClass: "function-height" },
                _vm._l(_vm.functionData, function (item, index) {
                  return _c(
                    "el-popover",
                    {
                      key: index,
                      staticClass: "function-pop",
                      attrs: {
                        placement: "right",
                        width: "200",
                        trigger: "hover",
                        "open-delay": 500,
                      },
                    },
                    [
                      _c("p", { staticClass: "pop-title" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _c("p", { staticClass: "pop-info" }, [
                        _vm._v(_vm._s(item.func)),
                      ]),
                      _c("p", { staticClass: "pop-info" }, [
                        _vm._v(_vm._s(item.desc)),
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "function-style",
                          attrs: { slot: "reference" },
                          on: {
                            click: function ($event) {
                              return _vm.insertParamToCodeMirror(item.func)
                            },
                          },
                          slot: "reference",
                        },
                        [_vm._v(_vm._s(item.func))]
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "de-foot" },
        [
          _c(
            "deBtn",
            { attrs: { secondary: "" }, on: { click: _vm.closeCalcField } },
            [_vm._v(_vm._s(_vm.$t("dataset.cancel")))]
          ),
          _c(
            "deBtn",
            {
              attrs: {
                disabled: !_vm.fieldForm.name || !_vm.fieldForm.originName,
                loading: _vm.loading,
                type: "primary",
              },
              on: { click: _vm.saveCalcField },
            },
            [_vm._v(_vm._s(_vm.$t("dataset.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }